import Image from 'next/image'
import Link from 'next/link'

import { Card } from '@wartek-id/card'
import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

import useToggleSdkContext from 'utils/useToogleSdk'

export function BannerUpdatedTargetPerilaku() {
  const toggles = useToggleSdkContext()
  const isUpdatedTargetPerilakuInfoEnabled =
    toggles?.['kinerja-updated-target-perilaku-info-enabled'] || false

  if (!isUpdatedTargetPerilakuInfoEnabled) return null

  return (
    <Card>
      <div className="flex gap-6 p-6">
        <div className="flex-shrink-0">
          <Image
            alt=""
            src="/illustrations/img-announcement-speaker.png"
            width={84}
            height={84}
            className="flex-shrink-0"
          />
        </div>
        <div className="flex flex-col gap-1 items-start">
          <Text variant="heading-sm">
            [Periode 2025] Data Target Perilaku Anda mungkin berubah. Cek
            Notifikasi untuk selengkapnya.
          </Text>
          <Text variant="body">
            Jika Anda tidak mendapatkan notifikasi Target Perilaku, abaikan info
            ini dan lanjutkan Pengelolaan Kinerja seperti biasa.
          </Text>
          <Link href="/pengelolaan-kinerja/notifikasi" passHref>
            <Button
              variant="ghost"
              size="sm"
              as="a"
              className="flex-shrink-0 -ml-2 hover:!bg-transparent"
            >
              Cek Notifikasi
            </Button>
          </Link>
        </div>
      </div>
    </Card>
  )
}
